import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import useIsLoggedIn from './useIsLoggedIn';
import { setEditProfile, setLoginModal } from '../Redux/generalOperationSlice/generalOperationSlice';
// import { navigate, replace, resetAndNavigate } from '../customAxios/RootNavigation';

const usePaymentValidation = () => {
  const userDetails = useSelector((state) => state.user?.userDetails);
  
  const {isLoginExpired} = useIsLoggedIn();
  const dispatch = useDispatch();

  const isPaymentAllowed = () => {
    if (!userDetails) {
      return false;
    } else {
      if (
        !userDetails?.email ||
        !userDetails?.first_name ||
        !userDetails?.last_name ||
        !userDetails?.address ||
        !userDetails?.city ||
        !userDetails?.state ||
        !userDetails?.pin_code ||
        !userDetails?.country
      ) return false;
      return true;
    }
  };

  const navigateToEditProfile = () => {
    if (!userDetails?.id && isLoginExpired(userDetails?.token)) {
        toast.error('Please login to proceed with payment');
        dispatch(setLoginModal(true));
    }else {
        toast.error('Please update your profile first.', { duration: 5000 });
        dispatch(setEditProfile(true));
    }
  }

  const warnUserBeforeBooking = (customMessage = "Please update your profile before payment. Your data will not be shared with anyone else.") => {
    if (!isPaymentAllowed()){
        toast.error(customMessage, { duration: 3000 });
    }
  }

  return { isPaymentAllowed, warnUserBeforeBooking, navigateToEditProfile };
};

export default usePaymentValidation;
